const getLocalRefreshToken = () => {
  return (
    localStorage.getItem('refreshToken') ||
    sessionStorage.getItem('refreshToken') ||
    false
  );
};

export default getLocalRefreshToken;
